/* import __COLOCATED_TEMPLATE__ from './image-editor.hbs.js'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isEmpty, isNone } from '@ember/utils';
import { next, debounce, throttle } from '@ember/runloop';
import { cleanUrl } from '@intercom/composer-ember/lib/helpers/clean-url';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
import { INLINE_CONTROL_ALIGNMENT } from '@intercom/composer-ember/lib/config/composer-config';
import { UPLOAD_IMAGE_PLACEHOLDER_CIRCLE, UPLOAD_IMAGE_PLACEHOLDER_RECTANGULAR, TEST_SUITE_PLACEHOLDER_IMAGE } from './media-inserter/constants';
let ImageEditor = (_dec = ref('linkUrlInputElement'), _dec2 = ref('altAttributeInputElement'), _class = class ImageEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isEditingLinkUrl", _descriptor, this);
    _initializerDefineProperty(this, "isEditingAltAttribute", _descriptor2, this);
    _initializerDefineProperty(this, "linkUrlInputElement", _descriptor3, this);
    _initializerDefineProperty(this, "altAttributeInputElement", _descriptor4, this);
    _defineProperty(this, "nodeSelection", undefined);
  }
  get composer() {
    return this.args.composer;
  }
  get node() {
    return this.selection?.node;
  }
  get selection() {
    return this.composer.state.prosemirrorState.selection;
  }
  get config() {
    return this.composer.config;
  }
  get isImagePlaceHolder() {
    return [UPLOAD_IMAGE_PLACEHOLDER_RECTANGULAR, UPLOAD_IMAGE_PLACEHOLDER_CIRCLE, TEST_SUITE_PLACEHOLDER_IMAGE].includes(this.node?.attrs.src);
  }
  get isVisible() {
    return this.selectedIsImage || this.selectedIsInlineImage;
  }
  get selectedIsImage() {
    return this.composer.state.prosemirrorState.schema.nodes.image && this.node?.type === this.composer.state.prosemirrorState.schema.nodes.image && !this.isImagePlaceHolder;
  }
  get selectedIsInlineImage() {
    return this.composer.state.prosemirrorState.schema.nodes.inlineImage && this.node?.type === this.composer.state.prosemirrorState.schema.nodes.inlineImage && !this.isImagePlaceHolder;
  }
  get showAlignment() {
    return this.config.allowTextAlignment && !this.config.hideFromBlockFormatter.includes(INLINE_CONTROL_ALIGNMENT);
  }
  get hasLinkUrl() {
    return !isEmpty(this.node?.attrs.linkUrl);
  }
  get hasAltAttribute() {
    return !isEmpty(this.node?.attrs.text);
  }
  get attributeInfoResolver() {
    return this.args.composer.config.templating?.resolver;
  }
  startEditingLinkUrl() {
    this.isEditingLinkUrl = true;
  }
  startEditingAltAttribute() {
    this.isEditingAltAttribute = true;
  }
  toggleCenter() {
    this.composer.commands.toggleCenter();
    this.composer.commands.focus();
  }
  removeLinkUrl() {
    this.composer.commands.updateSelectedNode({
      linkUrl: ''
    });
    this.isEditingLinkUrl = false;
  }
  removeAltAttribute() {
    this.composer.commands.updateSelectedNode({
      text: ''
    });
    this.isEditingAltAttribute = false;
  }
  updateLinkUrl() {
    if (this.linkUrlInputElement) {
      this.composer.commands.updateSelectedNode({
        linkUrl: cleanUrl(this.linkUrlInputElement.value)
      });
    }
  }
  updateAltAttribute() {
    if (this.altAttributeInputElement && this.nodeSelection) {
      this.composer.commands.updateNode(this.nodeSelection, {
        text: this.altAttributeInputElement.value
      });
      this.args.composer.config.analytics?.trackAnalyticsEvent('edited', {
        block_type: 'image',
        edited_attribute: 'image_alt_attribute'
      });
    }
  }
  onInsert(attributeTemplate, attributeTemplateStartPosition = 0, attributeTemplateEndPosition = 0) {
    if (this.linkUrlInputElement) {
      this.setSelectionRange(this.linkUrlInputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition);
    }
  }
  keyUp(e) {
    if (e.key === 'Enter') {
      this.isEditingLinkUrl = false;
      this.isEditingAltAttribute = false;
    }
  }
  focus(element) {
    next(this, () => {
      element.focus();
      this.nodeSelection = this.selection;
    });
  }
  clearIsEditingVariables() {
    this.isEditingLinkUrl = false;
    this.isEditingAltAttribute = false;
  }
  updateImage(file) {
    if (this.selection) {
      this.args.composer.commands.uploadImage(this.selection, file);
      this.args.composer.commands.focus();
      this.args.composer.config.analytics?.trackAnalyticsEvent('inserted', {
        block_type: 'image'
      });
    }
  }
  get imageDOM() {
    let dom = this.composer.state.editorView.nodeDOM(this.selection.$from.pos);

    // If the image is an inline image, the DOM element will already be the image
    return this.isInlineImage ? dom : dom?.querySelector('img');
  }
  get height() {
    if (this.hasSetDimensions) {
      return this.imageHeight;
    } else {
      return undefined;
    }
  }
  get width() {
    if (this.hasSetDimensions) {
      return this.imageWidth;
    } else {
      return undefined;
    }
  }
  get imageHeight() {
    return this.imageDOM?.clientHeight ?? 0;
  }
  get imageWidth() {
    let w = Number(this.node?.attrs.displayWidth);
    if (w) {
      return w;
    } else {
      return this.imageDOM?.clientWidth ?? 0;
    }
  }
  get hasSetDimensions() {
    return !!this.node?.attrs.displayWidth;
  }
  isArrowKeyInput(e) {
    let value = Number(e.target.value);
    return isNone(e.inputType) && Math.abs(value) === 1 && !this.node.attrs.displayWidth;
  }
  resizeHeight(e) {
    let value = Number(e.target.value);
    let ratio = this.imageWidth / Math.max(this.imageHeight, 1);

    // If inputType is undefined, it means the user is using the arrow keys to incresae/decrease the value
    // in this case we want to increment/decrement the inferred value from the height of the DOM element if there
    // is no existing value
    if (this.isArrowKeyInput(e)) {
      value += this.imageHeight;
      this.updateDisplayWidth(Number(value) * ratio);
    } else if (isNone(e.inputType)) {
      throttle(this, this.updateDisplayWidth, Number(value) * ratio, 50);
    } else {
      debounce(this, this.updateDisplayWidth, Number(value) * ratio, 250);
    }
  }
  resizeWidth(e) {
    let value = Number(e.target.value);
    // If inputType is undefined, it means the user is using the arrow keys to incresae/decrease the value
    // in this case we want to increment/decrement the inferred value from the width of the DOM element if there
    // is no existing value
    if (this.isArrowKeyInput(e)) {
      value += this.imageWidth;
      this.updateDisplayWidth(Number(value));
    } else if (isNone(e.inputType)) {
      throttle(this, this.updateDisplayWidth, Number(value), 50);
    } else {
      debounce(this, this.updateDisplayWidth, Number(value), 250);
    }
  }
  updateDisplayWidth(width) {
    if (width) {
      this.args.composer.commands.styling.updateImageDisplayWidth(width);
    } else {
      this.args.composer.commands.styling.removeImageDisplayWidth();
    }
  }
  get canUseInlineImages() {
    return this.args.composer.config.allowedInline.includes('inlineImage');
  }
  get isInlineImage() {
    return this.node?.type === this.composer.state.prosemirrorState.schema.nodes.inlineImage;
  }
  toggleInlineImage() {
    if (this.isInlineImage) {
      this.composer.commands.convertNodeTo(this.composer.state.prosemirrorState.schema.nodes.image, {
        type: 'image'
      });
    } else {
      this.composer.commands.convertNodeTo(this.composer.state.prosemirrorState.schema.nodes.inlineImage);
    }
  }
  setSelectionRange(inputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition) {
    let targetStartPosition = inputElement.value.length + attributeTemplateStartPosition;
    let targetEndPosition = inputElement.value.length + attributeTemplateEndPosition;
    inputElement.value += attributeTemplate;
    inputElement.focus();
    inputElement.setSelectionRange(targetStartPosition, targetEndPosition);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditingLinkUrl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEditingAltAttribute", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkUrlInputElement", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "altAttributeInputElement", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "startEditingLinkUrl", [action], Object.getOwnPropertyDescriptor(_class.prototype, "startEditingLinkUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startEditingAltAttribute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "startEditingAltAttribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCenter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCenter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeLinkUrl", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeLinkUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeAltAttribute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeAltAttribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLinkUrl", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateLinkUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAltAttribute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAltAttribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearIsEditingVariables", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearIsEditingVariables"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateImage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resizeHeight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resizeHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resizeWidth", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resizeWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleInlineImage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleInlineImage"), _class.prototype), _class);
export { ImageEditor as default };